//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
export default {
    name: "FileReplace",
    props:{
        prop:{
            type:String,
            default:""
        },
        label:{
            type:String,
            default:""
        },
        keyval:{
          type:Number,
          default:""
        },
        fileId:{
          type:Number,
          default:""
        },
        matchItem:{
          type:String,
          default:""
        },
        editItem:{
          type:String,
          default:""
        },
        lableWidth:{
          type:String,
          default:"100px"
        },
        maxSize:{//最大上传附件大小
          type:String,
          default:""
        },
        // 回调函数
        callbackFun:{
          type:Function,
          default:null
       },
       //是否兼容不用登陆访问
        nosession:{
            type:Boolean,
            default:false
        },
        uuid:{
          type:String,
          default:""
        }
    },
    data(){
       return {
            fileList: [],
            doUpload:'file/replaceFile',
            ifShowProgress:false,//是否展示进度条
            percentage:0,//百分比
       }
    },
    methods:{
        beforeAvatarUpload(file) {
           if(this.maxSize!=""&&this.maxSize!=undefined){
                if(this.cal.accSub(file.size, this.maxSize) > 0){
                    this.tipWarn(this.$t('contractcheck.checkMaxSize').replace("{0}",parseInt(this.maxSize)/1024/1024));
                    return false;
                }
           }
           return true;
        },
        // 上传
        async uploadFile(option) {
            //console.log('2019年09月24日19:54:18 FileUpload.vue[触发uploadFile]——[null] :',null);
            let formData = new FormData()
            formData.append("keyval",this.keyval);
            formData.append("fileid",this.fileId);
            formData.append('file', option.file);
            formData.append("uuid",this.uuid);
            let uid = option.file.uid;
            this.showProgress(uid);
            let config = {
                onUploadProgress: ProgressEvent => {
                    let progressPercent = parseInt((ProgressEvent.loaded / ProgressEvent.total * 100));
                    console.log("替换progressPercent:" + progressPercent);
                    this.setProgressPercent(uid, progressPercent);
                }
            }
            await axios.postUpload2(this.doUpload,formData,config).then((res) => {
                if ("1" === res.data.code) {
                     //this.setFileId(uid, res.data.data.fileid);
                     if(this.callbackFun){
                        this.callbackFun(this.fileId,option.file.name);    
                     }
                      let _this=this;
                     //this.ifShowProgress=false;
                     setTimeout(function()  {
                          _this.ifShowProgress=false;
                      }, 2000);
                }
            }).catch((error) => {
                console.log('2019年09月24日17:47:39 FileUpload.vue[上传失败]——[error] :', error)
            })
        },
        handleAvatarSuccess(res, file, fileList) {
        },
        clicka(file){
        },
        handleChange(file, fileList){
        },
        handleRemove(file, fileList){//删除附件
          
        },
        showProgress(uid) { //是否展示进度条
            this.ifShowProgress=true;
        },
        setProgressPercent(uid, progressPercent) { //设置百分比
            this.percentage=progressPercent;
        },
        setFileId(uid, fileId) { //设置回写的附件ID
        },
    },
    computed: {
        readonly: function () {
          if(this.fileId=="")
          {
            return true;
          }
          else{
            if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
              //返回true,设为只读
              return true;
            }else{
              return false;
            }
          }
        },

    },
    created(){
       if(this.nosession == true){
            this.doUpload = "onboarding/replaceFile";
        }
    }
}



// WEBPACK FOOTER //
// ./src/pccomponents/FileReplace.vue